import React, {Component} from "react";
import "./InquiriesPerUserHeader.css";
import {FormattedMessage} from "react-intl";

class InquiriesPerUserHeader extends Component {
    render() {
        return (
            <thead>
            <tr>
                <th>
                    <label>
                        <FormattedMessage id="app.inquiry-per-user-header.index"
                                          defaultMessage="#"
                                          description=""/>
                    </label>
                </th>
                <th>
                    <label>
                        日時
                    </label>
                </th>
                <th>
                    <label>
                        件名
                    </label>
                </th>
                <th>
                    <label>
                        NEW
                    </label>
                </th>
                <th>
                    <label>
                        <FormattedMessage id="app.inquiry-per-user-header-actions"
                                          defaultMessage="Actions"
                                          description=""/>
                    </label>
                </th>
            </tr>
            </thead>
        )
    }
}

export default InquiriesPerUserHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/InquiriesPerUser/InquiriesPerUserHeader/InquiriesPerUserHeader.js